import { useMutation } from '@tanstack/react-query';

import useUploadFileMutation from 'api/hooks/useUploadFileMutation';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

export const useUploadFiles = () => {
  const { request } = useMutationHTTPRequest();
  const { mutateAsync: uploadFile } = useUploadFileMutation();

  const { mutateAsync: getUploadUrl } = useMutation(
    async ({
      contentType,
      originalFilename,
    }: {
      contentType: string;
      originalFilename?: string;
    }) =>
      await request({
        url: '/api/media/upload-url/create',
        headers: {
          'object-content-type': contentType,
        },
        ...(originalFilename && {
          body: {
            originalFilename,
          },
        }),
      })
  );

  const uploadFiles = async (
    files: {
      file: File;
      originalFilename?: string;
    }[]
  ) =>
    await Promise.all(
      files.map(async ({ file, originalFilename }) => {
        const { mediaId, uploadUrl } = await getUploadUrl({
          contentType: file.type,
          originalFilename,
        });

        await uploadFile({
          file,
          presignedUrl: uploadUrl,
        });

        return mediaId;
      })
    );

  return { uploadFiles };
};
